import { $ } from "@/plug/Axios";

export default {
  /**
   * 采集字段
   */
  collectionField: {
    /*
     * 添加编辑采集字段
     * collectionId 数据采集ID (integer query )
     * dataType 数据类型（文本、数字、下拉、日期、图片、文档、附件） (string query )
     * displayCondition 显示条件 (string query )
     * displayName 显示名称 (string query )
     * displayStatus 显示状态(总是显示、条件显示） (string query )
     * dropdownContent 下拉值 (string query )
     * fieldLength 长度限制 (integer query )
     * id  (integer query )
     * requiredFlag 是否必填 (string query )
     * showFlag 是否管理端列表中显示 (string query )
     * sorting 顺序 (integer query )
     */
    post: (p, c) => $.post("/api/ems/collect/collectionField", p, c),

    /*
     * 删除采集字段
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/collect/collectionField", p, c)
  },
  collectionField_list: {
    /*
     * 采集字段列表
     * collectionId 采集id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/collect/collectionField/list", p, c)
  },

  /**
   * 资料收集
   */
  collectionRecord: {
    /*
     * 添加
     * content 筛选类型 (string query )
     * deadline 截止时间 (string query )
     * helperFileUrl 操作助手视频 (string query )
     * id  (integer query )
     * name 名称 (string query )
     * needAudit 是否班主任审核 (string query )
     * publishStatus 发布状态 (string query )
     * publishTime 发布时间 (string query )
     * type 筛选类型 (string query )
     */
    post: (p, c) => $.post("/api/ems/collect/collectionRecord", p, c),

    /*
     * 删除
     * id id (integer query )
     */
    delete: (p, c) => $.delete("/api/ems/collect/collectionRecord", p, c)
  },
  collectionRecord_listForEducation: {
    /*
     * 列表-教务
     */
    get: (p, c) =>
      $.get("/api/ems/collect/collectionRecord/listForEducation", p, c)
  },
  collectionRecord_listForService: {
    /*
     * 列表-服务
     */
    get: (p, c) =>
      $.get("/api/ems/collect/collectionRecord/listForService", p, c)
  },
  collectionRecord_publish: {
    /*
     * 发布
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/collect/collectionRecord/publish", p, c)
  },

  /**
   * 学生资料收集
   */
  collectionStudent_audit: {
    /*
     * 班主任审核
     * collectionId collectionId (integer query required)
     * remark 拒绝理由 (string query required)
     * schoolRollId schoolRollId (integer query required)
     * status 审核状态： 通过|拒绝 (string query required)
     */
    put: (p, c) => $.put("/api/ems/collect/collectionStudent/audit", p, c)
  },
  collectionStudent_commitFieldContent: {
    /*
     * 提交字段内容
     * fieldInfo 字段提交信息Json (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/collect/collectionStudent/commitFieldContent", p, c)
  },
  collectionStudent_commitFieldContentForClient: {
    /*
     * C端提交字段内容
     * fieldInfo 字段提交信息Json (string query )
     */
    put: (p, c) =>
      $.put(
        "/api/ems/collect/collectionStudent/commitFieldContentForClient",
        p,
        c
      )
  },
  collectionStudent_exportForEducation: {
    /*
     * 导出详情-学历配置-业务文件模板-学生资料收集
     * collectionId collectionId (integer query required)
     * type type (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/collect/collectionStudent/exportForEducation", p, c)
  },
  collectionStudent_exportForService: {
    /*
     * 导出-服务管理-学生资料收集
     * collectionId collectionId (integer query required)
     * type type (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/collect/collectionStudent/exportForService", p, c)
  },
  collectionStudent_getAllFieldsOfClass: {
    /*
     * 测试反射
     */
    put: (p, c) =>
      $.put("/api/ems/collect/collectionStudent/getAllFieldsOfClass", p, c)
  },
  collectionStudent_listForEducation: {
    /*
     * 教务列表-学历配置-业务文件模板-学生资料收集
     * collectionId collectionId (integer query required)
     * type type (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/collect/collectionStudent/listForEducation", p, c)
  },
  collectionStudent_listForService: {
    /*
     * 服务列表-服务管理-学生资料收集
     * collectionId collectionId (integer query required)
     * type type (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/collect/collectionStudent/listForService", p, c)
  },
  collectionStudent_searchByIdCardNo: {
    /*
     * 根据身份号查询信息
     * collectionId collectionId (integer query required)
     * idCardNo 身份证 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/collect/collectionStudent/searchByIdCardNo", p, c)
  },
  collectionStudent_searchFieldInfo: {
    /*
     * 获取编辑字段信息
     * collectionId collectionId (integer query required)
     * schoolRollId 合同编号 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/collect/collectionStudent/searchFieldInfo", p, c)
  }
};
